// hook to return a video thumb from a vimeo url
import { useEffect, useState } from "react";
const useGetVideoThumb = (videoHref) => {
    const [thumbnail, setThumbnail] = useState("");
    useEffect(() => {
        if (videoHref.includes("youtube") || videoHref.includes("youtu.be") || videoHref.includes("youtube-nocookie")) {
            const youtubeVideoId = getYoutubeVideoId(videoHref);
            setThumbnail(`https://img.youtube.com/vi/${youtubeVideoId}/hqdefault.jpg`);
        }
        if (videoHref.includes("vimeo")) {
            const videoId = getVimeoId(videoHref);
            if (videoId) {
                getVimeoThumb(videoId)
                    .then((thumb) => {
                    setThumbnail(thumb);
                })
                    .catch(() => {
                    // do not error in useEffect if vimeo request fails
                    setThumbnail("");
                });
            }
        }
    }, [videoHref]);
    return thumbnail;
};
export default useGetVideoThumb;
export async function getVimeoThumb(id) {
    if (!id) {
        return "";
    }
    const url = `https://vimeo.com/api/v2/video/${id}.json`;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data[0].thumbnail_large;
    }
    catch (error) {
        console.error("Error fetching Vimeo thumbnail:", error);
        throw error;
    }
}
function getYoutubeVideoId(url) {
    const regex = /(youtu.*?(?:be|nocookie).*?)\/(watch\?v=|embed\/|v\/|shorts\/|)(.*?((?=[&#?])|$))/gm;
    const urlMatch = regex.exec(url);
    if (!urlMatch) {
        return "";
    }
    return urlMatch[3];
}
function getVimeoId(url) {
    const regExp = /(?:vimeo\.com\/(?:.*\/)?)([a-zA-Z0-9]{6,20})\/?(?:[?#].*)?$/;
    const match = url.match(regExp);
    return match ? match[1] : null;
}
